import React from "react";
import { createPortal } from "react-dom";
import styles from "./Modal.module.scss";
import ExitIcon from "@shared/assets/icons/ExitIcon";

const Modal = ({ children, exit, title }) => {
  return createPortal(
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2 className={styles.headerTitle}>{title}</h2>
          <button onClick={exit}>
            <ExitIcon onClick={exit} />
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body,
  );
};

export default Modal;
